<div class="photo-outer">

  <post-text [text]="data.description" [expanded]="data.expanded"></post-text>
  
  <div class="photo-wrapper" (click)="$event.stopPropagation()">
    <p-image [src]="data.src" [alt]="data.title | multilang" [preview]="true"></p-image>
  </div>

</div>